import axios from 'axios'
import {identityTransport} from "@/api/transport/identity.transport"

export function loadProfiles(params, body = {}) {
  return identityTransport.post('/v1/internal/profile/list', body, { params })

  // return identityTransport.get('/v1/api/profile/list', { params })
}
